import { Database } from './Database';

export class Logger {
    static async getLevel(): Promise<string | null> {
        try {
            return Database.get('logLevel');
        } catch (e) {
            /* IndexedDB may not be accessible on browser profiles that restrict 3rd party cookies */
        }

        /* istanbul ignore next */
        return null;
    }

    static async setLevel(level: string | null): Promise<void> {
        try {
            await Database.set('logLevel', level);
        } catch (e) {
            /* IndexedDB may not be accessible on browser profiles that restrict 3rd party cookies */
        }
    }

    static async shouldLog(): Promise<boolean> {
        const logLevel: string | null = await Logger.getLevel();

        return logLevel === 'debug';
    }

    static trace(...args: unknown[]): (...args: unknown[]) => void {
        return console?.trace?.bind(console, ...args);
    }

    static log(...args: unknown[]): (...args: unknown[]) => void {
        return console?.log?.bind(console, ...args);
    }

    static debug(...args: unknown[]): (...args: unknown[]) => void {
        return console?.log?.bind(console, ...args);
    }

    static info(...args: unknown[]): (...args: unknown[]) => void {
        return console?.info?.bind(console, ...args);
    }

    static warn(...args: unknown[]): (...args: unknown[]) => void {
        return console?.warn?.bind(console, ...args);
    }

    static error(...args: unknown[]): (...args: unknown[]) => void {
        return console?.error?.bind(console, ...args);
    }
}
